import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
// import 'uikit/dist/css/uikit.min.css'
import '@/assets/css/custom-uikit/_custom-import.less'

UIkit.use(Icons)

export default () => {
    return UIkit
}